// extracted by mini-css-extract-plugin
export default {"content":"page_content__C3bxt","error":"page_error__7ogzV"};